import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import axios from "../Axios";
import How from "../How/How";
import Header from "../Header/Header";
import { ClapSpinner } from "react-spinners-kit";

const Login = () => {
    const [values, setValues] = useState({
        email: "",
        password: "",
    });
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [error2, setError2] = useState(null);
    const [emErr, setEmerr] = useState(null);
    const [passErr, setPasserr] = useState(null);
    const [emErr2, setEmerr2] = useState(null);
    const [passErr2, setPasserr2] = useState(null);
    const [loggedIn, setLogin] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(null);

    const emailRef = useRef();
    const passwordRef = useRef();
    const emailRefl = useRef();
    const passwordRefl = useRef();
    const howPage = useRef();
    const top = useRef();

    const handlePassword = () => {
        setShow(!show);
    };

    const focusColor = () => {
        emailRef.current.style.width = "100%";
        emailRef.current.style.transition = "0.4s";
    };
    const focusColor2 = () => {
        fnameRef.current.style.width = "49%";
        fnameRef.current.style.transition = "0.4s";
    };
    const blurColor = () => {
        emailRef.current.style.width = "0";
        emailRef.current.style.transition = "0.4s";
    };
    const blurColor2 = () => {
        fnameRef.current.style.width = "0";
        fnameRef.current.style.transition = "0.4s";
    };

    const focusColorl = () => {
        emailRefl.current.style.width = "100%";
        emailRefl.current.style.transition = "0.4s";
    };
    const focusColor2l = () => {
        passwordRefl.current.style.width = "100%";
        passwordRefl.current.style.transition = "0.4s";
    };
    const blurColorl = () => {
        emailRefl.current.style.width = "0";
        emailRefl.current.style.transition = "0.4s";
    };
    const blurColor2l = () => {
        passwordRefl.current.style.width = "0";
        passwordRefl.current.style.transition = "0.4s";
    };

    const scrolltoHow = () => {
        howPage.current.scrollIntoView({ behavior: "smooth" });
    };

    // signup//
    const [svalues, setsValues] = useState({
        email: "",
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
    });

    const [fname, setFname] = useState();
    const [laname, setLaname] = useState();
    const [usname, setUsname] = useState();
    const [signUp, setSignup] = useState(false);

    const fnameRef = useRef();
    const lnameRef = useRef();
    const usernameRef = useRef();

    const focusColor3 = () => {
        lnameRef.current.style.width = "49%";
        lnameRef.current.style.transition = "0.4s";
    };

    const blurColor3 = () => {
        lnameRef.current.style.width = "0";
        lnameRef.current.style.transition = "0.4s";
    };

    const focusColor4 = () => {
        usernameRef.current.style.width = "100%";
        usernameRef.current.style.transition = "0.4s";
    };

    const blurColor4 = () => {
        usernameRef.current.style.width = "0";
        usernameRef.current.style.transition = "0.4s";
    };

    const focusColor5 = () => {
        passwordRef.current.style.width = "100%";
        passwordRef.current.style.transition = "0.4s";
    };

    const blurColor5 = () => {
        passwordRef.current.style.width = "0";
        passwordRef.current.style.transition = "0.4s";
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setError2(null);
        setEmerr2(null);
        setFname(null);
        setLaname(null);
        setUsname(null);
        setPasserr(null);

        try {
            if (!svalues.email) {
                setEmerr2(true);
                return;
            } else {
                setEmerr2(null);
            }
            if (!svalues.firstName) {
                setFname(true);
                return;
            } else {
                setFname(null);
            }
            if (!svalues.lastName) {
                setLaname(true);
                return;
            } else {
                setLaname(null);
            }
            if (!svalues.userName) {
                setUsname(true);
                return;
            } else {
                setUsname(null);
            }
            if (!svalues.password) {
                setPasserr2(true);
                return;
            } else {
                setPasserr2(null);
                setSignup(true);
            }

            const { data } = await axios.post("/signup", svalues);

            if (data.Status === "Success") {
                navigate("/");
                setCookie("username", data.userName);
                setCookie("AuthToken", data.token);
                setSignup(false);
            } else if (data.detail === `duplicate key value violates unique constraint "registration_user_email_key"`) {
                setError2(
                    <span>
                        An account already exists with this email address. &nbsp;
                        <Link style={{ color: "#fe8402" }} to="/">
                            Sign in
                        </Link>
                    </span>
                );
                setEmerr2(true);
                setSignup(false);
            } else if (data.detail === `duplicate key value violates unique constraint "registration_user_name_key"`) {
                setError2("username is taken");
                setUsname(true);
                setSignup(false);
            } else if (data.detail) {
                setError2(data.detail);
                setSignup(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    // signup//

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);
        setEmerr(null);
        setPasserr(null);
        try {
            if (!values.email) {
                setError("Please enter an email address");
                setEmerr(true);
                return;
            } else {
                setEmerr(null);
            }
            if (!values.password) {
                setError("Please enter a password");
                setPasserr(true);
                return;
            } else {
                setPasserr(null);
                setLogin(true);
            }

            const { data } = await axios.post("/login", values);
            if (data.Status === "Success") {
                setCookie("email", data.email);
                setCookie("AuthToken", data.token);
                setCookie("username", data.username);
                navigate("/");
                setLogin(false);
            } else if (data.detail) {
                setError(data.detail);
                setLogin(false);
                if (data.detail === "* Email provided doesn't have an account") {
                    setEmerr(true);
                } else {
                    setEmerr(null);
                }
                if (data.detail === "* The Password you entered is incorrect") {
                    setPasserr(true);
                } else {
                    setPasserr(null);
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };
    // js//
    useEffect(() => {
        const loginForm = document.getElementById("loginSide");
        const signupForm = document.getElementById("signupSide");
        const formSwitch = document.querySelectorAll(".switchForm");
        const headerForm = document.getElementById("headerSide");
        const emailspan = document.getElementById("emailSpan");
        const emailInput = document.getElementById("emailInput");

        formSwitch[0].addEventListener("click", () => {
            loginForm.style.transform = "translateX(-104%)";
            signupForm.style.transform = "translateX(0)";
        });
        formSwitch[1].addEventListener("click", () => {
            loginForm.style.transform = "translateX(0)";
            signupForm.style.transform = "translateX(-100%)";
        });
        formSwitch[2].addEventListener("click", () => {
            loginForm.style.transform = "translateX(0)";
            signupForm.style.transform = "translateX(-100%)";
        });
        headerForm.addEventListener("click", () => {
            emailspan.classList.toggle("activespan2");
            loginForm.style.transform = "translateX(0)";
            signupForm.style.transform = "translateX(-100%)";
            if (!emailspan.classList.contains("activespan2")) {
                const emailTimeout = setTimeout(() => {
                    emailspan.classList.add("activespan2");
                }, 200);
                return () => {
                    clearTimeout(emailTimeout);
                };
            }
        });
        emailInput.addEventListener("focus", () => {
            emailspan.classList.add("activespan2");
        });
        document.addEventListener("click", (event) => {
            if (event.target != headerForm && event.target != emailInput) {
                emailspan.classList.remove("activespan2");
            }
        });
    }, []);

    //js//="

    return (
        <>
            <Header scrolltoHow={scrolltoHow} />
            <div className="login" ref={top}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-5 left col-11 me-md-3" id="formWrapper">
                            <form onSubmit={handleLogin} className="pb-3 form" id="loginSide">
                                <h3>Login to your account</h3>
                                <div className="d-inline-flex">
                                    <p>Don't have an account ? </p> &nbsp;
                                    <Link to="#">
                                        <p className="switchForm" style={{ color: "#da7000" }}>
                                            Create a new account
                                        </p>
                                    </Link>
                                </div>
                                {error && (
                                    <p className="pt-3" style={{ fontSize: "15px", color: "#c51244", marginBottom: "0" }}>
                                        {error}
                                    </p>
                                )}
                                <div className="loginInput" style={{ position: "relative", zIndex: "1" }}>
                                    <span style={{ position: "relative", width: "100%" }}>
                                        <input className={emErr ? "py-2 error" : "py-2"} type="text" placeholder="Your Email" name="email" id="emailInput" onChange={(e) => setValues({ ...values, email: e.target.value })}></input>
                                        <span ref={emailRefl} className="borderColorl activespan" id="emailSpan"></span>
                                    </span>
                                </div>

                                {loggedIn ? (
                                    <span style={{ left: "45%", zIndex: "2000", position: "absolute", top: "45%" }}>
                                        <ClapSpinner frontColor={"#fe8402"} backColor={"#00ff89"} size={50} loading={loggedIn} />
                                    </span>
                                ) : (
                                    ""
                                )}

                                <div className="my-2 loginInput" style={{ position: "relative", zIndex: "1" }}>
                                    <span style={{ position: "relative", width: "100%" }}>
                                        <input className={passErr ? "py-2 error" : "py-2"} type={!show ? "password" : "text"} placeholder="Your Password" name="password" onChange={(e) => setValues({ ...values, password: e.target.value })} onFocus={focusColor2l} onBlur={blurColor2l}></input>
                                        <span ref={passwordRefl} className="borderColor"></span>
                                    </span>

                                    {values.password && (show ? <i onClick={handlePassword} style={{ position: "absolute", right: "15.5%", top: "1.6rem", cursor: "pointer", color: show ? "#ff7f50" : "" }} className="fa-solid fa-eye"></i> : <i onClick={handlePassword} style={{ position: "absolute", right: "15.5%", top: "1.5rem", cursor: "pointer", opacity: "0.5", color: show ? "#ff7f50" : "" }} className="fa-regular fa-eye-slash onhover"></i>)}
                                </div>
                                <button className="py-2 text-white rounded blueButton">Log in</button>
                            </form>
                            <form onSubmit={handleSignup} id="signupSide" className="form signup">
                                <h3>Join the Network</h3>
                                <div className="d-inline-flex">
                                    <p>Already have an account ? </p> &nbsp;
                                    <Link to="#">
                                        <p className="switchForm" style={{ color: "#da7000" }}>
                                            Sign in
                                        </p>
                                    </Link>
                                </div>
                                {error2 && <p style={{ fontSize: "15px", color: "#c51244", marginBottom: "0" }}>{error2}</p>}
                                <div style={{ position: "relative", zIndex: "1" }}>
                                    <span style={{ position: "relative", width: "100%" }}>
                                        <input className={emErr2 ? "py-2 error" : "py-2"} type="text" placeholder="Email" name="email" onChange={(e) => setsValues({ ...svalues, email: e.target.value })} onFocus={focusColor} onBlur={blurColor}></input>
                                        <span ref={emailRef} className="borderColor"></span>
                                    </span>
                                </div>
                                {signUp ? (
                                    <span style={{ left: "45%", zIndex: "2000", position: "absolute", top: "40%" }}>
                                        <ClapSpinner frontColor={"#fe8402"} backColor={"#00ff89"} size={50} loading={signUp} />
                                    </span>
                                ) : (
                                    ""
                                )}
                                <div className="d-lg-inline-flex firstlast gap-2" style={{ position: "relative", zIndex: "1" }}>
                                    <input className={fname ? "py-2 inputFirst error" : "py-2 inputFirst"} type="text" placeholder="First Name" name="firstName" onChange={(e) => setsValues({ ...svalues, firstName: e.target.value })} onFocus={focusColor2} onBlur={blurColor2}></input>
                                    <span ref={fnameRef} className="borderColor2"></span>

                                    <input className={laname ? "py-2 inputSecond error" : "py-2 inputSecond"} type="text" placeholder="Last Name" name="lastName" onChange={(e) => setsValues({ ...svalues, lastName: e.target.value })} onFocus={focusColor3} onBlur={blurColor3}></input>
                                    <span ref={lnameRef} className="borderColor3"></span>
                                </div>
                                <div style={{ position: "relative", zIndex: "1" }}>
                                    <span style={{ position: "relative", width: "100%" }}>
                                        <input onFocus={focusColor4} onBlur={blurColor4} className={usname ? "py-2  error" : "py-2"} type="text" placeholder="username" name="userName" onChange={(e) => setsValues({ ...svalues, userName: e.target.value })}></input>
                                        <span ref={usernameRef} className="borderColor"></span>
                                    </span>
                                </div>
                                <div className="my-2" style={{ position: "relative", zIndex: "1" }}>
                                    <span style={{ position: "relative", width: "100%" }}>
                                        <input onFocus={focusColor5} onBlur={blurColor5} className={passErr2 ? "py-2  error" : "py-2"} type={show ? "text" : "password"} placeholder="Your Password" name="password" onChange={(e) => setsValues({ ...svalues, password: e.target.value })}></input>
                                        <span ref={passwordRef} className="borderColor"></span>
                                    </span>
                                    {svalues.password && (show ? <i onClick={handlePassword} style={{ position: "absolute", right: "15.5%", top: "1.6rem", cursor: "pointer", color: show ? "#ff7f50" : "" }} className="fa-solid fa-eye"></i> : <i onClick={handlePassword} style={{ position: "absolute", right: "15.5%", top: "1.5rem", cursor: "pointer", opacity: "0.5", color: show ? "#ff7f50" : "" }} className="fa-regular fa-eye-slash onhover"></i>)}
                                </div>
                                <p style={{ fontSize: "80%" }}>I agree to the privacy policy and terms of service</p>
                                <button className="agree py-2 rounded text-white">Agree and Join</button>
                                <Link to="#">
                                    <p className="switchForm" style={{ color: "#da7000", textAlign: "center", paddingBottom: "0", marginBottom: "0", paddingTop: "5px" }}>
                                        Already have an account?
                                    </p>
                                </Link>
                            </form>
                        </div>
                        <div className="col-md-5 right col-sm-12">
                            <p style={{ color: "#fe8402" }}>About</p>
                            <h1>Evangadi Networks Q & A</h1>
                            <p>
                                A questions and answers site, where one can ask or answer coding related questions. It's a space where a community of coding lovers and enthusiasts <br />
                                can come together and tackle technological challenges.
                            </p>
                            <p>A web-based platform that aims to help people be curious about coding, ask questions, discover answers and share their knowledge.</p>
                            <button onClick={scrolltoHow} className="py-2 text-white rounded howOutline">
                                How it works
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={howPage}>
                <How />
            </div>
            <div className="text-center py-1" style={{ backgroundColor: "#4f77aa", color: "white", cursor: "pointer" }} onClick={() => top.current.scrollIntoView()}>
                Back to Top
            </div>
        </>
    );
};

export default Login;
